export default "__VITE_ASSET__D6RTHj10__"